{
  "name": "neo-gallery",
  "version": "1.1.8",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.4",
    "@angular/cdk": "^20.2.8",
    "@angular/cli": "^20.3.5",
    "@angular/common": "^20.3.4",
    "@angular/compiler": "^20.3.4",
    "@angular/compiler-cli": "^20.3.4",
    "@angular/core": "^20.3.4",
    "@angular/forms": "^20.3.4",
    "@angular/material": "^20.2.8",
    "@angular/platform-browser": "^20.3.4",
    "@angular/platform-browser-dynamic": "^20.3.4",
    "@angular/router": "^20.3.4",
    "rxjs": "~7.8.2",
    "uuid": "^13.0.0",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^20.3.5",
    "@types/jasmine": "~5.1.9",
    "@types/uuid": "^11.0.0",
    "typescript": "5.9.3"
  }
}
